<template>
  <md-table
    v-model="cart"
    md-sort="order_id"
    md-sort-order="asc"
    table-header-color="primary"
    @md-selected="onSelect"
  >
    <md-table-toolbar
      slot="md-table-alternate-header"
      slot-scope="{ count }"
      class="md-danger"
    >
      <div class="md-toolbar-section-start">{{ getAlternateLabel(count) }}</div>
      <div class="md-toolbar-section-end">
        <md-button class="md-icon-button md-dense">
          <md-icon>delete</md-icon>
        </md-button>
      </div>
    </md-table-toolbar>
    <md-table-empty-state md-label="Your cart is empty." />
    <md-table-row
      slot="md-table-row"
      slot-scope="{ item }"
      md-selectable="multiple"
    >
      <md-table-cell md-label="Access Pass">
        <md-field>
          <md-select
            id="business_type"
            v-model="item.new_pass.type"
            name="business_type"
            md-dense
            @md-selected="updateCart"
          >
            <md-option value="none" disabled>
              Select access pass type...
            </md-option>
            <md-option
              v-for="(passType, id) in passTypes"
              :key="id"
              :value="passType.id"
              >{{ passType.name }}</md-option
            >
          </md-select>
        </md-field>
      </md-table-cell>
      <md-table-cell md-label="Name">
        {{ item.first_name + " " + item.last_name }}
      </md-table-cell>
      <md-table-cell md-label="Subtotal">
        ${{ centsToDollars(item.new_pass.price) }}
      </md-table-cell>
      <md-table-cell md-label="">
        <button
          style="all: unset; cursor: pointer"
          @click="$store.dispatch('removeItemFromCart', item)"
        >
          <md-icon>delete</md-icon>
        </button>
      </md-table-cell>
    </md-table-row>
  </md-table>
</template>
<script>
import { mapGetters } from "vuex";
import { centsToDollars } from "@/util";

export default {
  name: "CartTable",
  props: {
    dataBackgroundColor: {
      type: String,
      default: ""
    }
  },
  data() {
    return {};
  },
  computed: {
    cart: {
      get: function() {
        return this.$store.getters.cart;
      },
      set: function(items) {
        this.$store.dispatch("setCart", items);
      }
    },
    ...mapGetters(["passTypes"])
  },
  created() {
    this.$store.dispatch("getPassTypes");
  },
  methods: {
    onSelect(items) {
      this.selected = items;
    },
    getAlternateLabel(count) {
      let plural = "";

      if (count > 1) {
        plural = "s";
      }
      return `${count} item${plural} selected`;
    },
    updateCart() {
      this.cart.forEach(item => {
        this.setPassDetails(item.new_pass);
      });
      this.$store.dispatch("setCart", this.cart);
    },
    setPassDetails(pass) {
      let passType = this.passTypes.filter(passType => {
        return passType.id === pass.type;
      })[0];

      if (!passType) return;

      pass.price = passType.price;
      pass.name = passType.name;
    },
    centsToDollars: centsToDollars
  }
};
</script>
<style></style>
